import type { Component } from 'vue';
import LyricsCheckStatusColumn from '@/components/LyricsCheckStatusColumn.vue';
import PlaylistCountColumn from '@/components/PlaylistCountColumn.vue';
import RatingColumn from '@/components/RatingColumn.vue';

/**
 * Registry mapping LiveTrack table fields to custom cell components — the cell-level
 * sibling of {@link file:src/components/arrayColumns/index.ts}. ColumnMapping consults
 * this for LiveTrack table contexts (Search + Track Matching) instead of growing an
 * else-if chain; add an entry here to give the next column a custom renderer.
 */
export const liveTrackCellColumnRegistry: Record<string, Component> = {
  'lyrics_check_status.display_string': LyricsCheckStatusColumn,
  playlist_count: PlaylistCountColumn,
  rating: RatingColumn,
};

export function getLiveTrackCellColumn(field: string): Component | null {
  return liveTrackCellColumnRegistry[field] ?? null;
}
